<template>
    <div>
        <SoccerHowClassHeader :noneBorder="true" title="수업" :isMoney="false"></SoccerHowClassHeader>
        <div class="p-list preferences-wrap" style="padding:0px 20px;">
            <ul class="preferences">
                <li @click="showLesson">
                    <span>레슨권</span>
                </li>
                <li @click="showPurchase">
                    <span>구매내역</span>
                </li>
                <li @click="showNewLesson">
                    <span>출석/결석</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import SoccerHowClassHeader from "../../common/SoccerHowClassHeader";
    export default {
        name: "TempLessonList",
        components: {SoccerHowClassHeader},
        methods : {
            showPurchase() {
                this.$GlobalStore.addModal('MyMemberships', { saleCount: this.saleCount });
                // localStorage.setItem(MY_FEED_LAST_SALE_IDX, this.newLastSaleIdx);
                this.saleCount = 0;
            },
            showLesson(){
                this.$GlobalStore.addModal('MyMembershipsWithProgressing');
            },
            showNewLesson() {
                this.$GlobalStore.addModal('LessonSchedules', { reservationCount: this.reservationCount });
                // localStorage.setItem(MY_FEED_LAST_RESERVATION_IDX, this.newLastReservationIdx);
                this.reservationCount = 0;
            },
        }
    }
</script>

<style scoped>
    ul{    list-style: none; padding-left:0px;}
    .preferences-wrap h3 i {
        width: 17px;
        height: 17px;
        background: url("~@/assets/images/mypage/ico-set.png") 0 0 no-repeat;
        background-size: cover;
    }

    .p-list ul {
        margin-bottom: 33px;
    }

    .p-list ul li {
        font-size: 14px;
        line-height: 53px;
        border-bottom: 1px solid;
        border-color: #F5F5F5;
    }

    .p-list ul li a {
        display: inline-block;
        width: 100%;
        line-height: 53px;
    }

    .p-list ul li span {
        display: inline-block;
        position: relative;
        padding-right: 10px;
        box-sizing: border-box;
    }

    .p-list ul li:last-child {
        border-bottom: none;
    }
</style>